<template>
    <div class="w-full" >
        <form @submit.prevent="storePodcast">
            <div class="space-y-8">
                <div class="grid grid-cols-1 gap-y-1 md:gap-y-0 md:grid-cols-4 gap-x-6">
                    <div class="">
                        <label for="title" class="block font-medium text-gray-800 sm:mt-px sm:pt-2">
                            Podcast title
                        </label>
                    </div>
                    <div class="md:col-span-3">
                        <input type="text" name="title" v-model="form.title" class="rounded-lg w-full" required>
                        <InlineError v-if="form.errors.title" :message="form.errors.title"/>
                    </div>
                </div>
                <div class="grid grid-cols-1 gap-y-1 md:gap-y-0 md:grid-cols-4 gap-x-4">
                    <div class="">
                        <label for="description" class="block font-medium text-gray-800 sm:mt-px sm:pt-2">
                            Description
                        </label>
                    </div>
                    <div class="md:col-span-3">
                        <textarea v-model="form.description" name="description" rows="8" cols="80" class="w-full rounded-lg"></textarea>
                        <InlineError v-if="form.errors.description" :message="form.errors.description"/>
                    </div>
                </div>
                <div class="grid grid-cols-1 gap-y-1 md:gap-y-0 md:grid-cols-4 gap-x-4">
                    <div class="">
                        <label for="category" class="block font-medium text-gray-800 sm:mt-px sm:pt-2">
                            Category
                        </label>
                    </div>
                    <div class="md:col-span-3 relative">
                        <select v-model="form.category" class="w-full rounded-lg" required>
                            <template v-for="category in categories">
                                <option :value="category.id">{{ category.name }}</option>
                            </template>
                        </select>
                        <InlineError v-if="form.errors.category" :message="form.errors.category"/>
                    </div>
                </div>
                <div v-if="categories.find(el => el.id == form.category)?.subcategories.length" class="grid grid-cols-1 gap-y-1 md:gap-y-0 md:grid-cols-4 gap-x-4">
                    <div class="">
                        <label for="category" class="block font-medium text-gray-800 sm:mt-px sm:pt-2">
                            Subcategory
                        </label>
                        <div class="text-xs text-gray-700">
                            Optional
                        </div>
                    </div>
                    <div class="md:col-span-3 relative">
                        <select v-model="form.subcategory" class="w-full rounded-lg">
                            <template v-for="subcategory in categories?.find(el => el.id == form.category)?.subcategories">
                                <option :value="subcategory.id">{{ subcategory.name }}</option>
                            </template>
                        </select>
                    </div>
                </div>
                <div class="grid grid-cols-1 gap-y-1 md:gap-y-0 md:grid-cols-4 gap-x-4">
                    <div class="">
                        <label for="title" class="block font-medium text-gray-800 sm:mt-px sm:pt-2">
                            Podcast cover
                        </label>
                        <div class="text-xs text-gray-700">
                            PNG, JPG, GIF up to 10MB
                        </div>
                    </div>
                    <div class="md:col-span-3">
                        <div v-if="!imagePreview" class="w-full flex items-center">
                            <div class="flex flex-col items-center w-full md:w-auto">
                                <div class="flex flex-wrap md:space-x-2 space-y-1.5 md:space-y-0">
                                    <div @click="$refs.image.click()" class="w-full md:w-auto flex justify-center">
                                        <Button label="Upload image" type="primary outline"/>
                                    </div>
                                    <div @click="generateRandomImage" class="w-full md:w-auto flex justify-center">
                                        <Button label="Choose one for me" type="secondary" icon="LightningBoltIcon"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="imagePreview" class="w-full flex flex-col justify-center md:justify-start space-y-2 md:space-y-0 md:flex-row space-x-4 items-center">
                            <div class="w-48 h-48 relative">
                                <div class="w-48 h-48 absolute top-0 left-0 flex items-center justify-center z-10 bg-gray-400 rounded-lg">
                                    <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                </div>
                                <div class="w-48 h-48 absolute top-0 left-0 z-20 bg-center bg-cover rounded-lg" :style="'background-image: url(' + imagePreview + ')'" />
                            </div>

                            <div class="flex-1 flex flex-col items-center justify-center space-y-2">
                                <div @click="generateRandomImage">
                                    <Button label="Choose one for me" type="secondary" icon="LightningBoltIcon"/>
                                </div>
                                <div @click="removePreviewImage">
                                    <Button label="Remove image" type="danger outline" icon="TrashIcon"/>
                                </div>

                            </div>
                        </div>
                        <InlineError v-if="form.errors.image" :message="form.errors.image"/>
                        <input type="file" accept="image/*" ref="image" class="hidden" @input="updatePreviewImage"/>
                    </div>
                </div>
                <div class="w-full flex justify-center border-t border-t-gray-400 pt-8" :class="{ 'justify-between': podcast}">
                    <button v-if="!podcast" type="submit">
                        <Button label="Create podcast" :disabled="form.processing"/>
                    </button>
                    <div v-if="podcast" @click="deletePodcast">
                        <Button label="Delete podcast" :disabled="form.processing" type="danger"/>
                    </div>
                    <div v-if="podcast" @click="updatePodcast">
                        <Button label="Update podcast" :disabled="form.processing"/>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script setup>
import { ref, defineProps, watch, defineEmits, onMounted } from 'vue'
import Button from '@/Shared/Button'
import InlineError from '@/Shared/InlineError'
import { useForm } from '@inertiajs/inertia-vue3'
import axios from 'axios'
import { Inertia } from '@inertiajs/inertia'

const imagePreview = ref(null)
const imagePreviewFile = ref(null)
const imagePreviewId = ref(null)
const showList = ref(false)
const showButton = ref(false)
const image = ref(null)

const form = useForm({
    title: props.podcast?.title,
    description: props.podcast?.description,
    image: props.podcast?.image,
    category: props.podcast?.category?.id,
    subcategory: props.podcast?.subcategory?.id,
})

const props = defineProps([ 'categories', 'open', 'podcast', 'isDirty' ])

onMounted(() => {
    if (form.image) {
        imagePreview.value = form.image
    }
})

const emit = defineEmits(['update:isDirty', 'update:open'])

watch(form, (newConfig) => {
    emit('update:isDirty', form.isDirty)
}, { deep: true })

const resetView = () => {
    imagePreview.value = null
    imagePreviewId.value = null
    form.reset()
    emit('update:open', false)
}

const deletePodcast = () => {
    Inertia.delete(route('podcasts.destroy', props.podcast.uuid), {
        onSuccess: () => {
            resetView()
        }
    })
}

const storeWithImageUpload = (method, route) => {
    Vapor.store(imagePreviewFile.value, {
        progress: progress => {
        }
    }).then(response => {
        form.image = {
            uuid: response.uuid,
            key: response.key,
            bucket: response.bucket,
            name: imagePreviewFile.value.name,
            content_type: imagePreviewFile.value.type,
            extension: imagePreviewFile.value.name.split('.').pop() ?? null,
        }
        storeForm(method, route)
    })
}

const storeForm = (method, route) => {
    form[method](route, {
        preserveScroll: true,
        onSuccess: () => {
            resetView()
        }
    })
}

const storePodcast = () => {
    if (imagePreviewFile.value) {
        storeWithImageUpload('post', route('podcasts.store'))
    } else {
        storeForm('post', route('podcasts.store'))
    }
}

const updatePodcast = () => {
    if (!imagePreviewFile.value && !imagePreviewId.value && form.image) {
        form.image = 'unchanged'
    }
    if (imagePreviewFile.value) {
        storeWithImageUpload('patch', route('podcasts.update', props.podcast))
    } else {
        storeForm('patch', route('podcasts.update', props.podcast))
    }
}

const generateRandomImage = () => {
    axios.post(route('podcasts.artwork'), {
        id: imagePreviewId.value
    })
        .then(response => {
            imagePreview.value = response.data.url
            imagePreviewId.value = response.data.id
            form.image = response.data.url
        })
        .catch(error => {
            console.log(error)
        })
}

const updatePreviewImage = () => {
    imagePreview.value = URL.createObjectURL(image.value.files[0])
    imagePreviewFile.value = image.value.files[0]
}

const removePreviewImage = () => {
    imagePreview.value = null
    form.image = null
    imagePreviewId.value = null
}
</script>
